// general
export const RADIO = 'radio' as const
export const NUMBER = 'number' as const
export const CHECKBOX = 'checkbox' as const
export const TEXT = 'text' as const
export const ERROR = 'error' as const
export const TYPE = 'type' as const

// dispatchers
export const NEXT = 'NEXT' as const
export const NEXT_JSONTREE_QUESTION = 'NEXT_JSONTREE_QUESTION' as const
export const PREVIOUS = 'PREVIOUS' as const
export const BACK_JSONTREE_QUESTION = 'BACK_JSONTREE_QUESTION' as const
export const TOGGLE_JSON_TREE = 'TOGGLE_JSON_TREE' as const
export const UPDATE_CURRENT_QUESTION_TREE_ID =
	'UPDATE_CURRENT_QUESTION_TREE_ID' as const
export const END = 'END' as const
export const GO_TO_NEXT_JSON_TREE = 'GO_TO_NEXT_JSON_TREE' as const
export const UPDATE_STATE = 'UPDATE_STATE' as const
export const UPDATE_METADATA = 'UPDATE_METADATA' as const
export const SET_ENTIRE_STATE = 'SET_ENTIRE_STATE' as const
export const ADD_EDITABLE_PARENT = 'ADD_EDITABLE_PARENT' as const
export const SAVE_CURRENT_QUESTION_TREE_ID =
	'SAVE_CURRENT_QUESTION_TREE_ID' as const
export const UPDATE_INCLUDED_CONTROLLER_QUESTIONS =
	'UPDATE_INCLUDED_CONTROLLER_QUESTIONS' as const
export const UPDATE_LAST_ANSWERED_QUESTIONS =
	'UPDATE_LAST_ANSWERED_QUESTIONS' as const
export const SET_LANGUAGE = 'SET_LANGUAGE' as const
export const SET_INITIAL_QUESTION_TREE = 'SET_INITIAL_QUESTION_TREE' as const

// types
export const JSON_FORM = 'JSON_FORM' as const
export const REGULAR_FORM = 'REGULAR_FORM' as const
export const REGULAR_QUESTION_TREE = 'REGULAR_QUESTION_TREE' as const
export const DYNAMIC_QUESTION_TREE = 'DYNAMIC_QUESTION_TREE' as const
export const SET_MESSAGE = 'SET_MESSAGE' as const
